<div class="flex flex-col gap-2 bg-black rounded-lg p-2">
  <div class="text-white text-xs/18 font-semibold">{{ action().name }}</div>
  <div class="text-white text-[10px]">{{ action().description }}</div>
</div>
